/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {FetchMethod} from '@dvrd/dvr-controls';

export const URLS = {
    [FetchMethod.GET]: {
        USER: 'user',
        LOGOUT: 'auth/logout',
        LATEST_KM: 'distance/latest-km/{vehicle_id}',
        GET_VEHICLES: 'vehicle/all',
        GET_VEHICLE: 'vehicle/get/{vehicle_id}',
    },
    [FetchMethod.POST]: {
        LOGIN: 'auth/login',
        USER: '',
        CREATE_DISTANCE: 'distance/create',
        GET_DISTANCES: 'distance/all',
        EXPORT_DISTANCES: 'distance/export',
        GET_DISTANCE_INFO: 'distance/info',
        CREATE_VEHICLE: 'vehicle/create',
    },
    [FetchMethod.PUT]: {
        USER: '',
        UPDATE_DISTANCE: 'distance/update',
        UPDATE_VEHICLE: 'vehicle/update',
    },
    [FetchMethod.DELETE]: {
        USER: '',
        DELETE_DISTANCE: 'distance/delete/{distance_id}',
        DELETE_VEHICLE: 'vehicle/delete/{vehicle_id}',
    },
};

export const createParamUrl = (url: string, params: Record<string, string>) => {
    const keys = Object.keys(params);
    for (const key of keys)
        url = url.replace(`{${key}}`, params[key]);
    return url;
};